module.exports = __webpack_public_path__ + "static/img/dz.e8688062.svg";